import React from 'react';
import { AlertTriangle, Bell, CheckCircle2, FileSignature, Info } from 'lucide-react';

const TONES = {
  warning: { icon: AlertTriangle, color: '#B87430', background: '#FBEBCF' },
  action:  { icon: FileSignature, color: '#2c4f7a', background: '#DFEAF8' },
  notice:  { icon: Bell,          color: '#3D6B38', background: '#E3EEDD' },
  info:    { icon: Info,          color: '#5b5f5b', background: '#ECECEA' },
};

/**
 * Things that need the user, each with an optional time and action.
 * items: { id, tone: 'warning'|'action'|'notice'|'info', title, detail?, when?, action? }[]
 */
export const AttentionList = ({ items }) => {
  if (items.length === 0) {
    return (
      <div className="card-base px-4 py-4 flex items-center gap-3 text-[13px] text-lb-muted" role="status">
        <CheckCircle2 size={18} className="text-lb-green-primary flex-shrink-0" aria-hidden="true" />
        You’re all caught up.
      </div>
    );
  }
  return (
    <ul className="card-base list-none m-0 p-0 divide-y divide-black/[0.06]">
      {items.map(({ id, tone, title, detail, when, action }) => {
        const style = TONES[tone] || TONES.info;
        const Icon = style.icon;
        return (
          <li key={id} className="flex items-start gap-3 px-4 py-3">
            <span
              className="w-8 h-8 rounded-full flex items-center justify-center flex-shrink-0"
              style={{ background: style.background, color: style.color }}
              aria-hidden="true"
            >
              <Icon size={15} />
            </span>
            <div className="flex-1 min-w-0">
              <p className="m-0 text-[13px] font-semibold text-lb-ink-strong">{title}</p>
              {detail && <p className="m-0 mt-0.5 text-[12px] text-lb-muted leading-[1.45]">{detail}</p>}
            </div>
            {(when || action) && (
              <div className="flex flex-col items-end gap-1 flex-shrink-0">
                {when && <span className="text-[11px] text-lb-muted-soft whitespace-nowrap">{when}</span>}
                {action}
              </div>
            )}
          </li>
        );
      })}
    </ul>
  );
};
